var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2044 25C9.41309 25 8.84586 24.8044 8.50273 24.4133C8.16758 24.0133 8 23.3815 8 22.5178V7.48222C8 6.60074 8.17157 5.96889 8.5147 5.58667C8.86581 5.19556 9.42905 5 10.2044 5H18.0346C20.245 5 22.0743 7.18222 22.0743 9.85556C22.0743 11.8556 21.1766 13.4867 19.3812 14.4133C21.6993 14.8867 23 17.5067 23 19.4022C23 21.6933 21.9467 25 18.5313 25H10.2044ZM16.7359 16.1178H11.5909V21.9578H16.7359C17.7752 21.9578 19.2296 20.8244 19.2296 18.9978C19.2296 17.1711 17.7752 16.1178 16.7379 16.1178M11.5909 8.04444V13.2156H16.3389C17.0571 13.2156 18.5273 12.4667 18.5273 10.5578C18.5273 8.64667 16.9374 8.04444 16.3389 8.04444H11.5909Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBold);
export default __webpack_public_path__ + "static/media/text-bold.1c400ee1b9568bce8707213556d92c87.svg";
export { ForwardRef as ReactComponent };